import BaseClass from "./BaseClass";

class SharedAmocrmLicensesCost extends BaseClass {
  constructor(data) {
    super(data);
    this.tariff_name || (this.tariff_name = "");
    this.limits ||
      (this.limits = {
        leads: null,
        contacts: null,
        cf: null
      });
    this.tariff_cost || (this.tariff_cost = Object.create(null));
  }

  static getDataList(variables = {}) {
    return this._api.query({
      query: require("../../graphql/amo_licenses/shared_amocrm_licenses_cost_list.graphql"),
      variables: variables
    });
  }

  save() {
    return this._api
      .mutate({
        mutation: require("../../graphql/amo_licenses/shared_amocrm_licenses_cost_save.graphql"),
        variables: this
      })
      .then(res => {
        Object.assign(this, res.data.shared_amocrm_licenses_cost);
        return "saved";
      });
  }

  delete() {
    return this._confirm("Are you sure want to delete this period?").then(
      () => {
        return this._api.mutate({
          mutation: require("../../graphql/amo_licenses/shared_amocrm_licenses_cost_save.graphql"),
          variables: Object.assign({ action: "delete" }, this)
        });
      }
    );
  }

  static get schema() {
    return {
      tariff_name: {
        editable: true,
        props: { sortable: true, resizable: true }
      },
      tariff_cost: {
        editable: true,
        field: "_tariffCostValue",
        type: Object,
        props: { sortable: false, resizable: true }
      },
      limits: {
        editable: true,
        field: "_limitsValue",
        label: "leads / contacts / cf",
        type: Object,
        props: { sortable: false, resizable: true }
      }
      // created_at: {
      //     props: { sortable: true, resizable: true }
      // },
      // updated_at: {
      //     props: { sortable: true }
      // }
    };
  }

  get _limitsValue() {
    try {
      return ["leads", "contacts", "cf"]
        .reduce((r, v) => {
          try {
            r.push(this.limits[v] || "☠");
          } catch (e) {
            r.push("☠");
          }
          return r;
        }, [])
        .join(" / ");
    } catch (e) {
      return "";
    }
  }

  get _tariffCostValue() {
    try {
      let r = Object.keys(this.tariff_cost)
        .sort()
        .reduce((r, v) => {
          try {
            r.push(`${v} ${this.tariff_cost[v]}`);
          } catch (e) {}
          return r;
        }, [])
        .join(" | ");
      return r.length ? r : "☠";
    } catch (e) {
      return "";
    }
  }

  beShownForFilterString(filter) {
    if (!this.uuid) {
      return false;
    }
    return (
      !filter || this.tariff_name.toLowerCase().includes(filter.toLowerCase())
    );
  }

  _handleSave() {
    return this._api
      .mutate({
        mutation: require("../../graphql/periods/periods_save.graphql"),
        variables: Object.assign({ trial: !!this.trial }, this)
      })
      .then(res => {
        Object.assign(this, res.data.directory_periods);
        return "saved";
      });
  }

  _handleDelete() {
    return this._confirm("Are you sure want to delete this period?")
      .then(() => {
        return this._api
          .mutate({
            mutation: require("../../graphql/periods/periods_save.graphql"),
            variables: Object.assign({ action: "delete" }, this)
          })
          .then(res => {
            return "deleted";
          });
      })
      .catch(() => {
        return "scipped";
      });
  }

  _handleCancel() {
    if (typeof this.uuid === "undefined") {
      return Promise.reject();
    } else {
      return Promise.resolve("canceled");
    }
  }
}

export default SharedAmocrmLicensesCost;
